import type { SerializedStyles } from '@emotion/react';
import { css } from '@emotion/react';

import figtreeFont from '@/fonts/figtree.woff2';

const WaterThemeDefault = (): SerializedStyles => css`
  * {
    box-sizing: border-box;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    margin: 0;
    padding: 0;
    outline: none;
    font-family: 'Figtree', 'Inter', 'Segoe UI', 'Roboto', system-ui, sans-serif;

    &:-webkit-autofill,
    &:-webkit-autofill:hover,
    &:-webkit-autofill:focus,
    &:-webkit-autofill:active {
      -webkit-box-shadow: 0 0 0 30px white inset !important;
      -webkit-text-fill-color: inherit !important;
      transition: background-color 5000s ease-in-out 0s;
    }
  }

  @font-face {
    font-family: 'Figtree';
    src: url('${figtreeFont}') format('woff2');
    font-weight: 100 900;
    font-style: normal;
    font-display: swap;
  }

  html {
    overflow-x: hidden;

    /**
      Para o GLDetailedModal, quando o modal estiver aberto,
    */
    &.no-scroll {
      overflow: hidden;
    }
    font-size: 100%; // change this to adjust the default rem size. Example: 62.5% will make 1rem = 10px

    &:has(body.scroll-locked) {
      overflow: hidden;
    }

    &::-webkit-scrollbar {
      width: 0 !important;
      background: transparent !important;
    }

    scrollbar-width: none !important;
    -ms-overflow-style: none !important;
  }

  button {
    cursor: pointer;
  }
`;

export { WaterThemeDefault };
